import $ from 'jquery';
import Choices from 'choices.js';
import Utils from '../utils/Utils.js';
const initCustomSelect = () => {
    const selectElements = document.querySelectorAll('.custom-select');
    const getValueFromPath = (obj, path) => {
        // Si le chemin ne contient pas de point, accédez directement à la clé
        if (!path.includes('.')) {
            return obj[path] !== undefined ? obj[path] : undefined;
        }

        // Sinon, divisez le chemin et parcourez l'objet
        return path.split('.').reduce((acc, key) => {
            return acc && acc[key] !== undefined ? acc[key] : undefined;
        }, obj);
    };
    selectElements.forEach(selectElement => {
        // Vérifier si l'élément est déjà initialisé
        if (selectElement.classList.contains('choices__input')) {
            return;
        }

        const placeholder = selectElement.querySelectorAll('option').innerText
        const choices = new Choices(selectElement, {
            placeholder: true,
            searchChoices: false,
            maxItemCount: 1,
            searchResultLimit: 4,
            removeItemButton: true,
            loadingText: 'Chargement...',
            noResultsText: 'Aucun résultat trouvé',
            noChoicesText: 'Aucun choix disponible',
            itemSelectText: 'Sélectionner',
            uniqueItemText: 'Seules des valeurs uniques peuvent être ajoutées',
            customAddItemText: 'Seules les valeurs correspondant à des conditions spécifiques peuvent être ajoutées',
            allowHTML: true
        });
        
        // Fonction pour effectuer la requête fetch
        const fetchCompanies = (searchTerm) => {
            const url = `https://suggestions.pappers.fr/v2?cibles=nom_entreprise,siren,siret&q=${encodeURIComponent(searchTerm)}`;

            fetch(url)
                .then(response => response.json())
                .then(data => {
                    // Utiliser un Set pour éviter les doublons
                    const uniqueResults = new Set();

                    // Récupérer tous les résultats des cibles
                    const choicesData = [];

                    // Parcourir les clés de l'objet résultats
                    for (const key of Object.keys(data)) {
                        const items = data[key];
                        
                        if (items.length > 0) {
                            items.forEach(item => {
                                if (!uniqueResults.has(item.siren)) {
                                    uniqueResults.add(item.siren);
                                    choicesData.push({
                                        label: `${item.nom_entreprise} ${item.siege.code_postal ? `(${item.siege.code_postal})` : ''}`,
                                        value: item.siret ? item.siret : item.siren,
                                        customProperties: { ...item }
                                    });
                                }
                            });
                        }
                    }
                    choicesData.reverse()
                    // Effacer les choix existants et ajouter les nouveaux choix
                    choices.clearChoices();
                    choices.setChoices(choicesData);
                })
                .catch(error => {
                    console.error('Erreur lors de la requête fetch:', error);
                });
        };



        // Appliquer le debounce à la fonction fetchCompanies avec un délai de 1000ms
        const debouncedFetchCompanies = Utils.debounce(fetchCompanies, 1000);

        // Ajouter l'écouteur d'événement
        selectElement.addEventListener('search', function (event) {
            const searchTerm = event.detail.value;
            if (searchTerm && searchTerm.length > 1) {
                debouncedFetchCompanies(searchTerm);
            }
        });




        selectElement.addEventListener('choice', function (event) {
            const selectedItem = event.detail.choice.customProperties;
            const prefillData = JSON.parse(selectElement.getAttribute('data-prefill'));
            const parentForm = selectElement.closest('.formBloc, .form-popup');
            const effectifSIRENE = {
                "00": "0 salarié",
                "01": "1 ou 2 salariés",
                "02": "3 à 5 salariés",
                "03": "6 à 9 salariés",
                "11": "10 à 19 salariés",
                "12": "20 à 49 salariés",
                "21": "50 à 99 salariés",
                "22": "100 à 199 salariés",
                "31": "200 à 499 salariés",
                "41": "500 à 999 salariés",
                "42": "1000 à 1999 salariés",
                "51": "2000 à 4999 salariés",
                "52": "5000 salariés ou plus",
                "NN": "Effectif inconnu"
            };

            // Fonction pour obtenir la valeur à partir d'un chemin
            const getValueFromPath = (obj, path) => {
                return path.split('.').reduce((acc, key) => {
                    return acc && acc[key] !== undefined ? acc[key] : undefined;
                }, obj);
            };

            // Remplissez les champs appropriés avec les valeurs de prefillData
            for (const [key, value] of Object.entries(prefillData)) {
                const field = parentForm.querySelector(`#${value}`);
                if (field) {
                    // Utilisez la fonction pour obtenir la valeur depuis selectedItem
                    const selectedValue = getValueFromPath(selectedItem, key);
                    if (selectedValue !== undefined) {
                        setTimeout(() => {
                            if (key == "tranche_effectif") {
                                field.value = effectifSIRENE[selectedValue] ? effectifSIRENE[selectedValue] : effectifSIRENE["00"];
                            } else {
                                field.value = selectedValue;
                            }
                            // Déclenche l'événement 'input' pour notifier les changements
                            field.dispatchEvent(new Event('input', { bubbles: true }));
                        }, 200);
                    }
                }
            }
        });



        // Ajoutez un écouteur d'événements pour le retrait d'un item
        selectElement.addEventListener('removeItem', function (event) {
            const parentForm = selectElement.closest('.formBloc, .form-popup');
            // Effacer les valeurs des champs lorsque l'item est retiré
            const prefillData = JSON.parse(selectElement.getAttribute('data-prefill'));
            for (const value of Object.values(prefillData)) {
                const field = parentForm.querySelector(`#${value}`);
                if (field) {
                    field.value = ''; // Vider le champ
                    field.dispatchEvent(new Event('input', { bubbles: true }));
                }
            }
        });

    });
};

export { initCustomSelect };
